import React from "react";
import { AiOutlineForm } from 'react-icons/ai';

const ExpReg = () => {

    return (
        <div className='pt-10'>
            <div className=" p-6 max-w-2xl mx-auto bg-white rounded-xl shadow-md flex items-center flex-col">            
                <h1 className=' font-bold text-principal text-2xl pb-4 font-sans'>Expedición de Registros</h1>

                <p className='text-xl font-sans text-center'>
                    Las copias del registro de nacimiento, matrimonio y defunción, que sirven para probar los hechos o actos relativos al estado civil, pueden ser solicitadas presencialmente en las registradurías autorizadas a nivel nacional, a través de los correos electrónicos habilitados por departamento o en donde se encuentra el folio respectivo.
                </p>

                <a
                    href={`https://wa.me/+573104032213?text=Hola,%20quiero%20solicitar%20información%20sobre%20Expedición%20de%20Registros.`} target="_blank" rel="noopener noreferrer"
                    className='text-center bg-principal text-white py-2 px-6 rounded-full border-2 border-principal font-semibold mt-4 hover:bg-white hover:text-principal hover:scale-95 transition-all duration-200 ease-out'>
                    <AiOutlineForm size={25} className='inline-block mr-2' />
                    Solicitar
                </a>

            </div>
        </div>
    );
}

export default ExpReg;